import { render, staticRenderFns } from "./ManageDepartmentList.vue?vue&type=template&id=31570e4a&scoped=true"
import script from "./ManageDepartmentList.vue?vue&type=script&lang=js"
export * from "./ManageDepartmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31570e4a",
  null
  
)

export default component.exports